import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Typography } from '@mui/material';
import React from 'react';

import { muiPalette } from '@/shared/general-theme';

import {
  ContentBox,
  ContentSection,
  ErrorCode,
  StyledButton,
} from './not-found-page.styled.ts';

const NotFoundPage: React.FC = () => {
  return (
    <ContentSection>
      <ErrorCode>404</ErrorCode>
      <ContentBox>
        <Typography variant='h3' component='h1' sx={{ fontWeight: 'bold', mb: 1 }}>
          We're sorry,
        </Typography>
        <Typography variant='h3' component='h2' sx={{ fontWeight: 'bold', mb: 5 }}>
          we couldn't find this page
        </Typography>
        <Typography variant="body1" sx={{ mb: 5, fontSize: '1.125rem', color: muiPalette.text.secondary }}>
          The page you're looking for may have been moved or is temporarily unavailable.
        </Typography>
        <StyledButton
          variant='contained'
          color='primary'
          endIcon={<ArrowForwardIcon />}
          href='/'
        >
          Return to homepage
        </StyledButton>
      </ContentBox>
    </ContentSection>
  );
};

export default NotFoundPage;